import React from 'react';
import { CarIcon, HouseIcon, MoonIcon, RepeatIcon, ScanLineIcon, TimerIcon, UtensilsCrossedIcon } from 'lucide-react';
import type { FactKind } from '../../utils/treatmentFacts';
const icons = {
  guidance: ScanLineIcon,
  duration: TimerIcon,
  home: HouseIcon,
  sessions: RepeatIcon,
  sedation: MoonIcon,
  fasting: UtensilsCrossedIcon,
  driving: CarIcon
} as const;
interface FactIconProps {
  kind: FactKind;
  className?: string;
}
export function FactIcon({
  kind,
  className = 'h-4 w-4'
}: FactIconProps) {
  const Icon = icons[kind];
  return <Icon className={className} aria-hidden="true" data-id="element-300" data-mp="berxrs6gj7ch" />;
}